type ReportPromoUrlConfigType = {
  page?: number;
  size?: number;
  search: string;
  dateAfter: string | null;
  dateBefore: string | null;
  activityIds: number[];
  citiesIds: number[];
  rolesIds: number[];
  status: string;
  pagination?: boolean;
};

export const reportPromoUrlConfig = ({
  search,
  dateAfter,
  dateBefore,
  activityIds,
  citiesIds,
  rolesIds,
  status,
  size,
  page,
  pagination = true,
}: ReportPromoUrlConfigType): string => {
  const searchParams = search ? `&search_query=${search}` : '';
  const dateAfterParams = dateAfter ? `&participation_after=${dateAfter}` : '';
  const dateBeforeParams = dateBefore ? `&participation_before=${dateBefore}` : '';
  const activityIdsParams = activityIds.length !== 0 ? `&activity_ids=${activityIds.join('&activity_ids=')}` : '';
  const citiesIdParams =
    citiesIds && citiesIds.length > 0 ? `&sales_point_city_ids=${citiesIds.join('&sales_point_city_ids=')}` : '';
  const rolesIdParams = rolesIds.length !== 0 ? `&user_role_ids=${rolesIds.join('&user_role_ids=')}` : '';
  const statusParams = status ? `&participation_status=${status}` : '';
  const sizeParams = size && pagination ? `size=${size}` : '';
  const pageParams = page && pagination ? `&page=${page}` : '';

  return `${sizeParams}${pageParams}${searchParams}${activityIdsParams}${dateAfterParams}${dateBeforeParams}${citiesIdParams}${statusParams}${rolesIdParams}&wallet_app_type=b2b`;
};
